// Debugging confirmation
console.log('✅ config.js loaded successfully!');

// ✅ Global Configuration Object
export const APP_CONFIG = {
  //  BASE_URL: "http://localhost:3000",
  // BASE_URL: "http://localhost:5500",
  // BASE_URL: "http://127.0.0.1:5500",
  //   BASE_URL: "https://towobo-depolyment-slot-main.azurewebsites.net",
  //  BASE_URL: "https://streamsta-196bd.web.app",

  //    IMAGES_BASE_URL: "https://my-towobo-cdn-endpoint-bzcbcgdphpaaf5eg.z02.azurefd.net/towobo-images-blob-main/wwwroot/",
  IMAGES_BASE_URL: 'https://storage.googleapis.com/towobo_bucket_main/wwwroot/',
  // IMAGES_BASE_URL: "http://34.120.123.238/wwwroot/", // IPV4 http://34.120.123.238/wwwroot/imgs/homecur/pots.png
  // IMAGES_BASE_URL: "http://34.120.123.238:80/wwwroot/", // IPV6 example http://34.120.123.238:80/wwwroot/imgs/homecur/pots.png

  // Least we forget Using google CDN and hostom gon google increased lgiht house score from 56 to 96

  VALID_LANGUAGE_CODES: ['en', 'us', 'fr', 'es', 'de', 'zh', 'it', 'pt', 'tr', 'ja', 'ko', 'ar'],
  VALID_LANGUAGES: [
    //{ code: "en", name: "English (UK)" },
    //{ code: "us", name: "English (US)" },
    //{ code: "fr", name: "Français" },
    //{ code: "es", name: "Español" },
    //{ code: "de", name: "Deutsch" },
    //{ code: "zh", name: "简体中文" },
    //{ code: "it", name: "Italiano" },
    //{ code: "pt", name: "Português" },
    //{ code: "tr", name: "Türk" },
    //{ code: "ja", name: "日本語" },
    //{ code: "ko", name: "한국어" },
    //{ code: "ar", name: "عربى" },
    { code: 'en', name: 'English (UK)' },
    { code: 'us', name: 'English (US)' },
    { code: 'fr', name: 'French' },
    { code: 'es', name: 'Spanish' },
    { code: 'de', name: 'German' },
    { code: 'zh', name: 'Chinese' },
    { code: 'it', name: 'Italian' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'tr', name: 'Turkish' },
    { code: 'ja', name: 'Japanese' },
    { code: 'ko', name: 'Korean' },
    { code: 'ar', name: 'Arabic' },
  ],
  API_ENDPOINTS: {
    AUTH: '/api/auth',
    USER_PROFILE: '/api/user/profile',
  // CatalogAPI: 'https://localhost:7009',
    // CatalogAPI: "https://towobo-api.azurewebsites.net",
      CatalogAPI: "https://towobo-api-depolyment-slot-main.azurewebsites.net",
  },
};

// ✅ Set of keys that should persist across sessions
export const PERSISTENT_KEYS = new Set([
  'MyLoggedInUserID',
  'MyBuyingEntityID',
  'MyBuyingEntityType',
  'MyBuyingEntityCompanyName',
  'MyUserID', 
  'SiteLanguageCookie',
  'SiteCurrencyCodeCookie',
  'SiteShipToCountryIDCookie',
  'SiteShipToStateIDCookie',
  'SiteShipToCityCookie',
  'SiteShipToCountryCodeTwoCookie',
  'SiteShipToCountryCodeThreeCookie',
  'SiteShipToCountryNameCookie',
  'SiteCurrencyCodeCookie',
  'SiteCurrencyRateCookie',
  'SiteCurrencySignSingleCookie',
  'SiteCurrencySignMultipleCookie',
  'SearchSettingsSortBy',
  'SearchSettingsItemsPerPage',
  'SearchSettingsGroupRelated',
  'SearchFilters',
  'ListOfSpecOptionsSelectedFilters',
  'MyUserLastPageVisitedListing',
  'GDPRConsentSetCookie',
  'GDPRPreferences',
  'GDPRStatistics',
    'GDPRMarketing',
    'PhoneNumberCallingCodeID1',
    'PhoneNumberCallingCodeID2',
    'MyValueContactUsPageIssueID',


]);
